// Remembers the last course/topic/card opened in the editor so the next
// session can restore it. Used by SelectCourse (course) and CardEditor
// (topic/card).

const STORAGE_KEY = 'nanoms-last-edited';

export function loadLastEdited() {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return stored && stored.courseId ? stored : null;
    } catch {
        return null;
    }
}

export function saveLastEdited({ courseId, topicId, cardId }) {
    if (!courseId) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
        courseId,
        topicId: topicId || null,
        cardId: cardId || null,
    }));
}
